import React from 'react';
import i18next from 'i18next';

import { DATA_TEST_ID } from '~constants/tests';
import LottieIcon from '~components/LottieIcon';

import styles from './styles.module.scss';

function EmptyCart() {
  return (
    <>
      <LottieIcon height={140} width={180} icon="foodMenu" loop className={styles.icon} />
      <p data-testid={DATA_TEST_ID.emptyCart} className={`text-brand-primary m-bottom-1 ${styles.title}`}>
        {i18next.t('EmptyCart:noItemsTitle')}
      </p>
      <p className={styles.subtitle}>{i18next.t('EmptyCart:noItemsSubtitle')}</p>
    </>
  );
}
export default EmptyCart;
